import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeContextProvider } from './contexts/ThemeContext.js';
import { ModalContextProvider } from './contexts/ModalContext.js';
import { ResponsiveContextProvider } from './contexts/ResponsiveContext.js';
import { ServerContextProvider } from './contexts/ServerContext.js';
import App from './App.jsx';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<ResponsiveContextProvider>
		<ThemeContextProvider>	
			<ModalContextProvider>
				<ServerContextProvider>
					<Router>
						<React.StrictMode>
							<App />
						</React.StrictMode>
					</Router>
				</ServerContextProvider>
			</ModalContextProvider>
		</ThemeContextProvider>
	</ResponsiveContextProvider>
);

export const emptySpace = String.fromCharCode(160);